module.exports = __webpack_public_path__ + "img/sauropod.91910196.png";